export const environment = {
  production: false,
  encryptionKey: 'n2r5u8x!A%D*G-KaPdSgVkYp3s6v9y$B?E(H+MbQeThWmZq4t7w!z%C*F)J@NcRf',
  apiUrl: 'https://dev-highbridge.probanker.com/api/',
  notificationEmail: 'notifications@probanker.com',
  stripePublicKey:
    'pk_test_51LkyaYB14tfF25XZo5yAUMS7TTdpVN8IL4x04ahMSFtwRK1NQBjtoysz1t2TTvmyrj3MpRZy6KJOOz2sZL4tD94y00hnTHo29N',
};
